"use strict";
exports.__esModule = true;
exports.SLC_CLASSIC_APPROVED_SEPTEMBER_EXPERIMENT_CONTENT = exports.SLC_CLASSIC_APPROVED_CONTENT = void 0;
exports.SLC_CLASSIC_APPROVED_CONTENT = {
    HEADER: 'You’re approved!',
    BODY: 'You’ve officially been approved for a {{rentAmount}} Flex secured line of credit to pay your rent in full and on time.',
    CTA: 'Continue'
};
exports.SLC_CLASSIC_APPROVED_SEPTEMBER_EXPERIMENT_CONTENT = {
    HEADER: "You've been approved!",
    BODY: "You've been approved for a secured line of credit for {{rentAmount}} (your rent amount). Flex will use this to pay your rent in full and on time.",
    CTA: 'Continue'
};
